// extracted by mini-css-extract-plugin
export default {"toolDetails__collapseCell":"ProjectToolTableRow_toolDetails__collapseCell__v-zq3"};